export interface GutschriftPreis {
    gp_id?: number;
    kosten_netto: number;
    mwstsatz: number;
}

export class Gutschrift {
    gutschrift_id: number;
    lieferant_id: number;
    lieferant: string;
    artikel_id: number;
    artikel: string;
    konto_nr?: string;
    betrag: number;
    pdf_id: number;
    mwstsatz: number;
    primanota_id: number;
    datum: Date;
    gutschrift_nr: string;
    kommentar?: string;
    erstellt: Date;
    editiert: Date;
    bestellung_extern_id: number;
    gutschrift_id_storno: number;
    gutschrift_id_storniert: number;
    scan_review?: number;
    invoice_draft_id?: number;
    wawi_run_id?: number;
    positionen?: any[];
    preise?: GutschriftPreis[];
}

export function groupGutschriftPreise(
    rows: Array<{ kosten_netto?: number; kostenNetto?: number; mwstsatz?: number }> | null | undefined,
): GutschriftPreis[] {
    const map = new Map<number, number>();
    for (const r of rows || []) {
        const mwst = Number(r.mwstsatz);
        const netto = Number(r.kosten_netto ?? r.kostenNetto) || 0;
        if (!Number.isFinite(mwst)) {
            continue;
        }
        map.set(mwst, (map.get(mwst) || 0) + netto);
    }
    return [...map.entries()]
        .sort((a, b) => a[0] - b[0])
        .map(([mwstsatz, kosten_netto]) => ({ mwstsatz, kosten_netto }));
}

